import { useEffect, useRef } from 'react';
import {
    Card,
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from '@/components';

import {
    BIAS_CATEGORIES,
    BIAS_HIGHLIGHT_COLORS,
    BIAS_REASONS,
} from '@/config/app';
import { cn } from '@/lib/utils';

type BiasLegendProps = {
    biasFilter: string;
    setBiasFilter: (value: string) => void;
};

export function BiasLegend({ biasFilter, setBiasFilter }: BiasLegendProps) {
    const ref = useRef<HTMLDivElement>(null);
    useEffect(() => {
        scrollToBottom();
    }, []);

    const scrollToBottom = () => {
        ref.current?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <Card className="p-4 mb-4" ref={ref}>
            <div className="flex justify-between">
                <div>
                    <h3 className="font-semibold mb-2">Bias Categories</h3>
                    <div className="flex flex-wrap gap-2">
                        {Object.entries(BIAS_CATEGORIES).map(([key, value]) => (
                            <TooltipProvider key={key}>
                                <Tooltip>
                                    <TooltipTrigger asChild>
                                        <div className="flex items-center cursor-pointer">
                                            <div
                                                className={cn(
                                                    'w-4 h-4 rounded mr-1',
                                                    `${BIAS_HIGHLIGHT_COLORS[key]}`
                                                )}
                                            ></div>
                                            <span className="text-sm">
                                                {value}
                                            </span>
                                        </div>
                                    </TooltipTrigger>
                                    <TooltipContent>
                                        <p>
                                            {
                                                BIAS_REASONS[
                                                    key as keyof typeof BIAS_REASONS
                                                ]
                                            }
                                        </p>
                                    </TooltipContent>
                                </Tooltip>
                            </TooltipProvider>
                        ))}
                    </div>
                </div>
            </div>
        </Card>
    );
}
